import React from 'react';
import { Link } from 'react-router-dom';
import Icons from './Icons';

const HeroSection = () => {
  return (
    <section className="hero" id="inicio">
      <div className="container">
        <div className="hero-content">
          <h1 className="hero-title">
            Encuentra servicios confiables en todo Estados Unidos,
            <span className="hero-highlight"> en un solo lugar.</span>
          </h1>
          <p className="hero-description">
            Conecta con profesionales verificados en múltiples áreas, todo en un solo lugar.
          </p>
          <div className="hero-buttons">
            <Link to="/explora" className="btn btn-primary">Buscar Servicios</Link>
            <Link to="/profesionales/unete" className="btn btn-secondary">Soy Profesional</Link>
          </div>
          <div className="hero-disclaimer">
            <p className="disclaimer-text">
              <strong>Aviso importante:</strong> GesOps es un directorio que conecta personas con empresas y profesionales verificados.
              No compartimos honorarios ni ofrecemos asesoría legal directa.
            </p>
          </div>
        </div>
        <div className="hero-image">
          <div className="hero-graphic">
            <div className="justice-icon"><Icons.Scale /></div>
            <div className="stats">
              <div className="stat">
                <span className="stat-number">+100</span>
                <span className="stat-label">Profesionales verificados</span>
              </div>
              <div className="stat">
                <span className="stat-number">51</span>
                <span className="stat-label">Estados + Puerto Rico</span>
              </div>
              <div className="stat">
                <span className="stat-number">100%</span>
                <span className="stat-label">Contacto Directo</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
